import React from 'react';
export const Footer = () => {
  return <footer className="bg-white text-black" data-id="element-148">
      <div className="container mx-auto px-4 md:px-8 py-12" data-id="element-149">
        <div className="w-full border-t border-gray-200 mb-10" data-id="element-150"></div>
        <div className="flex justify-center mb-8" data-id="element-151">
          {/* Brand */}
          <div className="text-center" data-id="element-152">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/c3cHYA7ZXGrrozMXZWUHQe/Screenshot_2025-07-07_at_9.46.04_PM.png" alt="Ikigai Real Estate" className="h-16 mb-4 p-2 rounded mx-auto" data-id="element-153" />
          </div>
        </div>
        <div className="border-t border-gray-200 mt-8 pt-8 text-center" data-id="element-154">
          <p data-id="element-155">© 2025 https://ikigaire.ae. All rights reserved.</p>
        </div>
      </div>
    </footer>;
};